module.exports = __webpack_public_path__ + "static/media/solucionesHidrotermicas.aea0c473.jpg";